import axios from "./axios";

class DeviceService {
  getDevicePrice = async (device_name, quantity) => {
    try {
      const response = await axios.post("/device/get_price", {
        device_name,
        quantity,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  orderDevice = async (device_name, quantity) => {
    try {
      const response = await axios.post("/device/order_device", {
        device_name,
        quantity,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new DeviceService();
